import baseURLv1 from '@/services/APIConfig.js';
import { add, append, remove, set, update } from '@/vuex/helpers';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    statuses: [],
    allStatuses: [],
    filters: {
      order_by: 'name',
      page: 1,
      page_size: 10,
    },
    previous: null,
    next: null,
  },
  mutations: {
    set,
    update,
    add,
    remove,
    append,
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
  },
  actions: {
    async addStatus({ commit }, { payload }) {
      const company = await this.$axios.post(`${baseURLv1}/permit/status/`, payload);
      commit('add', ['statuses', company.data.data]);
    },

    async editStatus({ commit }, { status, id }) {
      const response = await this.$axios.patch(`${baseURLv1}/permit/status/${id}/`, status);

      commit('update', ['statuses', { id, payload: response.data.data }]);
    },

    async getStatusDetails({ commit }, { id }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/status/${id}/`);

      return response.data.data;
    },

    async deleteStatus({ commit }, id ) {
      const response = await this.$axios.delete(`${baseURLv1}/permit/status/${id}/`);

      commit('remove', ['statuses', id]);
      return response.data.data;
    },

    async load({ state, commit }) {
      commit('set', ['isLoading', true]);
      const response = await this.$axios.get(`${baseURLv1}/permit/status/`, {
        params: {
          ...state.filters,
        },
      });

      commit('set', ['statuses', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
      commit('set', ['isLoading', false]);
    },
    async loadAllStatuses({ _, commit }) {
      const response = await this.$axios.get(`${baseURLv1}/permit/status/`, {
        params: {
          page_size: 1000,
        },
      });

      commit('set', ['allStatuses', response.data.data]);
    },
  },
  getters: {
    selectOptions: (state) =>
      state.allStatuses
        .map((status) => ({
          id: status.id,
          name: status.name,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
  },
};
